export const FREIGHTIQ = {
  // Nav
  navLogo: "fiq-nav-logo",
  navStartCta: "fiq-nav-start-cta",
  navWorkspaceCta: "fiq-nav-workspace-cta",
  navProblem: "fiq-nav-link-problem",
  navHow: "fiq-nav-link-how",
  navWhy: "fiq-nav-link-why",
  navFaq: "fiq-nav-link-faq",

  // Hero
  heroEyebrow: "fiq-hero-eyebrow",
  heroHeadline: "fiq-hero-headline",
  heroSubheadline: "fiq-hero-subheadline",
  heroDescription: "fiq-hero-description",
  heroPrimaryCta: "fiq-hero-primary-cta",
  heroSecondaryCta: "fiq-hero-secondary-cta",
  heroTrustBar: "fiq-hero-trust-bar",
  heroDashboard: "fiq-hero-dashboard",
  heroDashboardShipment: "fiq-hero-dashboard-shipment",
  heroDashboardCarrier: "fiq-hero-dashboard-carrier",
  heroDashboardContainer: "fiq-hero-dashboard-container",
  heroDashboardRoute: "fiq-hero-dashboard-route",
  heroDashboardEta: "fiq-hero-dashboard-eta",

  // Problem
  problemSection: "fiq-problem-section",
  problemEmailCard: "fiq-problem-email-card",
  problemWorkspaceCard: "fiq-problem-workspace-card",

  // How it works
  howSection: "fiq-how-section",
  howStep: (i) => `fiq-how-step-${i}`,

  // Live dashboard
  liveDashboardSection: "fiq-live-dashboard-section",
  liveDashboardPanel: (k) => `fiq-live-dashboard-panel-${k}`,

  // Why FreightIQ
  whySection: "fiq-why-section",
  whyCard: (i) => `fiq-why-card-${i}`,

  // Connected workspace
  connectedSection: "fiq-connected-section",
  connectedNode: (i) => `fiq-connected-node-${i}`,

  // Outcomes
  outcomesSection: "fiq-outcomes-section",
  outcomeCard: (i) => `fiq-outcome-card-${i}`,

  // FAQ
  faqSection: "fiq-faq-section",
  faqItem: (i) => `fiq-faq-item-${i}`,

  // Final CTA
  finalCta: "fiq-final-cta-section",
  finalCtaPrimary: "fiq-final-cta-primary",
  finalCtaSecondary: "fiq-final-cta-secondary",

  // Footer
  footer: "fiq-footer",

  // Waitlist modal
  waitlistDialog: "fiq-waitlist-dialog",
  waitlistTrigger: "fiq-waitlist-trigger",
  waitlistName: "fiq-waitlist-name",
  waitlistEmail: "fiq-waitlist-email",
  waitlistCompany: "fiq-waitlist-company",
  waitlistRole: "fiq-waitlist-role",
  waitlistVolume: "fiq-waitlist-volume",
  waitlistSubmit: "fiq-waitlist-submit",
  waitlistSuccess: "fiq-waitlist-success",
};
